import { setAppStore } from './AppStore';
import { initAppStoreAndSagaMiddleware } from './CreateAppStore';
import { rootSaga } from './sagas/RootSaga';

export function initReduxStore() {
  // Create the Redux store, associate it with the Root Saga,
  // and inject it into the container where the rest of the app can retrieve it.
  // We use this pattern to avoid cyclic imports between sagas/services and the store/reducer.

  const { store, sagaMiddleware } = initAppStoreAndSagaMiddleware();
  sagaMiddleware.run(rootSaga);
  setAppStore(store);
}
